import { createContext } from "react";
import { makeAutoObservable, observable, toJS  } from "mobx";
import { naocDailyProductionService } from "../services/naocdailyproductionservice";
import { saveAs } from "file-saver";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
class NaocDailyProductionStore {
  constructor() {
    makeAutoObservable(this);
  }

  showNaocDailyProductionDialog = false;
  dailyProductions = observable.map({});
  selTab = "1";
  showSQeryDialog = false;
  isDownloadingTemplate = false;

  isExporting = false;
  isSaving = false;
  IsEquityProduction = 0;
  isLoading = false;
  isLoadingDailyProd = false;
  isLoaded = false;
  sheetName = "";
  showUploadErrorMessage = false;
  productionview = "gross";
  showRemarkPane = false;
  remarkObj = { title: "", remark: "<div></div>" };
  resultFromQuery = false;

  view = "upload";
  uploadDate = moment(new Date()).format("DD-MMM-YYYY");
  gridHeaderText = `NAOC JV(Gross) PRODUCTIONS from ${moment(new Date())
    .startOf("month")
    .format("ddd DD-MMM-YYYY")} to ${moment(new Date())
    .endOf("month")
    .format("ddd DD-MMM-YYYY")}`;
  initFormaData = {
    akriGasInjToOGutaPlant: 0,
    akriGasToOGutaPlant: 0,
    beniboyeOilDailyMetered: 0,
    dailyFuelGasToEPCL: 0,
    dailyGasDeliveryToBonny: 0,
    dailyGasDeliveryToRSIPP: 0,
    dailyGasEPCLFertPLT: 0,
    dailyGasJVIPP: 0,
    kwaleGpGasInj: 0,
    landAreaGas: 0,
    landAreaOil: 0,
    naocDailyProductionId: 0,
    nglDelivered: 0,
    gasInternallyUtilizedforNGL: 0,
    nglProduced: 0,
    obGpGasInj: 0,
    productionDate: moment(new Date()).format("DD-MMM-YYYY"),
    swampAreaRemarks: "",
    landAreaRemarks: "",
    swampAreaGas: 0,
    swampAreaOil: 0,

    totalGasFlared: 0,
    totalGasInternallyUtilized: 0,
    totalGasProduced: 0,
    totalGasRecKwaleGp: 0,
    totalGasRecOBGp: 0,
    totalOilMeteredProd: 0,
    totalOilProduced: 0,
    mtdUptime: "",
    ytdUptime: "",
    platform: 0,
    spdcAkriOguta: 0,
    spdcOgbainAfuo: 0,
    spdcOshie: 0,
    spdcSamabiriBiseni: 0,
    spdcTebidaba: 0,
    addax: 0,
    agbara: 0,
    pillarNewton: 0,
  };
  uploadErrors = [];
  selRow = {};
  queryCriteria = {
    startDate: moment(new Date())
      .startOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    endDate: moment(new Date())
      .endOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    fromInception: false,
    specificDate: false,
  };
  disableCommand = true;
  showPODExportAsExcelDialog = false;
  showNaocOilRythmDrawer = false;
  isOpeningNaocOilRythmDrawer = false;

  openNaocOilRythmDrawer() {
    this.isOpeningNaocOilRythmDrawer = true;

    setTimeout(() => {
      this.showNaocOilRythmDrawer = true;
      this.isOpeningNaocOilRythmDrawer = false;
    }, 150);
  }

  async DownlaodDailyProductionTemplate() {
    try {
      this.isDownloadingTemplate = true;
      const res = await naocDailyProductionService.downloadTemplate();
      saveAs(res, "NaocProductionTemplate.xlsx");
    } catch (error) {
      throw error;
    } finally {
      this.isDownloadingTemplate = false;
    }
  }

  async loadProductions() {
    try {
      this.isLoading = true;
      let res = [];
      res = await naocDailyProductionService.loadProductionHistory(
        this.queryCriteria,
        this.productionview
      );
      const prodHistory = Array.isArray(res?.prodHistory) ? res.prodHistory : [];

      this.dailyProductions.clear();
      prodHistory.forEach((prod) => {
        this.dailyProductions.set(prod.naocDailyProductionId, {
          ...prod,
          productionDate: moment(prod.productionDate).format("L"),
          strippedSARemarks: prod.swampAreaRemarks
            ? prod.swampAreaRemarks.replace(/(<([^>]+)>)/gi, " ")
            : null,
          strippedLARemarks: prod.landAreaRemarks
            ? prod.landAreaRemarks.replace(/(<([^>]+)>)/gi, " ")
            : null,
          pdYear: moment(prod.productionDate).format("YYYY"),
          pdYearMonth: moment(prod.productionDate).format("YYYY-MMM"),
        });
      });
      this.isLoaded = true;
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async saveDailyProduction(data) {
    try {
      this.isSaving = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const res = await naocDailyProductionService.saveDailyProduction(
        {
          ...data,
          productionDate:
            data.productionDate.charAt(0) === "-"
              ? data.productionDate.substr(1)
              : data.productionDate,
        },
        uploadedBy
      );
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }
  get isValidProductionData() {
    const { totalOilProduced, nglProduced } = toJS(this.initFormaData);
    return totalOilProduced + this.totalGasProduced + nglProduced >= 0;
  }

  async deleteProduction(id) {
    try {
      const retVal = await naocDailyProductionService.deleteProduction(id);
      return retVal;
    } catch (error) {
      throw error;
    }
  }
  clearFormValues() {
    let init = {
      akriGasInjToOGutaPlant: 0,
      akriGasToOGutaPlant: 0,
      beniboyeOilDailyMetered: 0,
      dailyFuelGasToEPCL: 0,
      dailyGasDeliveryToBonny: 0,
      dailyGasDeliveryToRSIPP: 0,
      dailyGasEPCLFertPLT: 0,
      dailyGasJVIPP: 0,
      kwaleGpGasInj: 0,
      landAreaGas: 0,
      landAreaOil: 0,
      naocDailyProductionId: 0,
      nglDelivered: 0,
      gasInternallyUtilizedforNGL: 0,
      nglProduced: 0,
      obGpGasInj: 0,
      productionDate: moment(new Date()).format("DD-MMM-YYYY"),
      swampAreaRemarks: "",
      landAreaRemarks: "",
      swampAreaGas: 0,
      swampAreaOil: 0,
      platform: 0,
      spdcAkriOguta: 0,
      spdcOgbainAfuo: 0,
      spdcOshie: 0,
      spdcSamabiriBiseni: 0,
      spdcTebidaba: 0,
      addax: 0,
      agbara: 0,
      pillarNewton: 0,
      totalGasEvacuated: 0,
      totalGasFlared: 0,
      totalGasInternallyUtilized: 0,
      totalGasProduced: 0,
      totalGasRecKwaleGp: 0,
      totalGasRecOBGp: 0,

      totalOilMeteredProd: 0,
      totalOilProduced: 0,
    };
    this.initFormaData = init;
    this.uploadDate = moment(new Date())._d;
  }

  get totalGasEvacuated() {
    const {
      dailyFuelGasToEPCL,
      dailyGasDeliveryToRSIPP,
      dailyGasDeliveryToBonny,
      dailyGasJVIPP,
      dailyGasEPCLFertPLT,
    } = toJS(this.initFormaData);
    return (
      dailyFuelGasToEPCL +
      dailyGasDeliveryToRSIPP +
      dailyGasDeliveryToBonny +
      dailyGasJVIPP +
      dailyGasEPCLFertPLT
    );
  }

  get totalGasProduced() {
    const { landAreaGas, swampAreaGas } = toJS(this.initFormaData);

    return landAreaGas + swampAreaGas;
  }

  get totalSpdcUnitizedShare() {
    const {
      spdcAkriOguta,
      spdcOgbainAfuo,
      spdcSamabiriBiseni,
      spdcTebidaba,
      spdcOshie,
    } = toJS(this.initFormaData);

    return (
      spdcAkriOguta +
      spdcOgbainAfuo +
      spdcSamabiriBiseni +
      spdcTebidaba +
      spdcOshie
    );
  }

  get totalUnitizedShare() {
    const {
      spdcAkriOguta,
      spdcOgbainAfuo,
      spdcSamabiriBiseni,
      spdcTebidaba,
      spdcOshie,
      pillarNewton,
    } = toJS(this.initFormaData);

    return (
      spdcAkriOguta +
      spdcOgbainAfuo +
      spdcSamabiriBiseni +
      spdcTebidaba +
      spdcOshie +
      pillarNewton
    );
  }

  async exportPodSummary(exportDate) {
    try {
      this.isExporting = true;
      const [startDate, endDate] = exportDate;
      const res = await naocDailyProductionService.exportPodSummary(
        moment(startDate).format("MM/DD/YYYY"),
        moment(endDate).format("MM/DD/YYYY")
      );

      saveAs(res, "pod_flash_summary_export.xlsx",{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    } catch (error) {
      throw error;
    } finally {
      this.isExporting = false;
    }
  }

  async getNaocDailProductionById(productionId) {
    try {
      this.isLoadingDailyProd = true;
      const retVal = await naocDailyProductionService.getNaocDailProductionById(
        productionId,
        this.IsEquityProduction
      );
      console.log(retVal);
      this.initFormaData = retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isLoadingDailyProd = false;
    }
  }
}


export default createContext(new NaocDailyProductionStore());

